export var Styles;
(function (Styles) {
    Styles["BORDER_DASH_STYLE"] = "Dash";
    Styles["FONT_WEIGHT_BOLD"] = "700";
    Styles["FONT_WEIGHT_NORMAL"] = "400";
    Styles["FONT_WEIGHT_SEMI_BOLD"] = "600";
    Styles["FONT_SIZE_10"] = "0.625rem";
    Styles["FONT_SIZE_12"] = "0.75rem";
    Styles["FONT_SIZE_14"] = "0.875rem";
    Styles["FONT_SIZE_16"] = "1rem";
    Styles["OUTLINE_NONE"] = "none";
    Styles["OPEN_SANS"] = "OpenSans";
    Styles["OPEN_SANS_BOLD"] = "OpenSans-Bold";
    Styles["OPEN_SANS_SEMIBOLD"] = "OpenSans-Semibold";
    Styles["POPPINS"] = "Poppins-Regular";
    Styles["POPPINS_MEDIUM"] = "Poppins-Medium";
    Styles["UNDERLINE"] = "underline";
    Styles["NO_WRAP"] = "nowrap";
    Styles["NORMAL"] = "normal";
    Styles["SHADOW_ELEVATION_THREE"] = "0 3px 5px 0 rgba(0, 0, 0, 0.36)";
})(Styles || (Styles = {}));
export var Colors;
(function (Colors) {
    Colors["PROGRESS_BAR_LINES"] = "#979797";
    Colors["WHITE_TRANSPARENT"] = "#E6E6E6";
    Colors["WHITE"] = "#FFF";
    Colors["PASTEL_WHITE"] = "#E2E2E2";
    Colors["GRAY"] = "#767676";
    Colors["SHADOW_COLOR"] = "rgba(0, 0, 0, 0.5)";
    Colors["TRANSPARENT"] = "transparent";
    Colors["BLACK"] = "#000";
    Colors["GRAY_LIGHT"] = "#CDCDCD";
    Colors["GRAY_LIGHT_TINT"] = "#D8D8D8";
    Colors["GRAY_LIGHTER"] = "#e2e2e2";
    Colors["GRAY_DUSTY"] = "#939393";
    Colors["YELLOW_TRANSPARENT"] = "#FDF6EB";
    Colors["YELLOW_LIGHTER"] = "#efa83461";
    Colors["YELLOW_DARK"] = "#FFBA4A";
    Colors["YELLOW_DARKER"] = "#E5A439";
    Colors["BLUE_LIGHTER"] = "#0072ee";
    Colors["BLUE_LIGHT"] = "#80B8F7";
    Colors["BLUE_DARKER"] = "#59A3F6";
    Colors["DEEP_LILAC"] = "#9251AC";
    Colors["GREEN_TRANSPARENT"] = "#E6F3E6";
    Colors["GREEN_LIGHT"] = "#35AA35";
    Colors["GREEN_DARK"] = "#3c8725";
    Colors["GREEN_DARK_HOVER"] = "#326F20";
    Colors["GREEN"] = "#35AA35";
    Colors["GREEN_DARKER"] = "#2A9A2A";
    Colors["ORANGE"] = "#ee7421";
    Colors["ORANGE_DARK"] = "#e4841b";
    Colors["RED_LIGHTER"] = "#FAEBEC";
    Colors["LABEL_RED"] = "#cc333f";
    Colors["RED_DARK"] = "#BC4044";
    Colors["LABEL_RED_HOVER"] = "#B42934";
    Colors["BLANCHI_GREEN"] = "#33bdcd";
    Colors["BLANCHI_GREEN__DARKER"] = "#04A3B9";
    Colors["BLUE_DARK"] = "#2150a3";
    Colors["GRAY_DARKER"] = "#333";
    Colors["BLACK_TRANSLUCENT_LIGHTEST"] = "rgba(0, 0, 0, 0.1)";
    Colors["PLUM"] = "#902364";
    Colors["LABEL_BLUE_TRANSPARENT"] = "#584CE41A";
    Colors["LABEL_BLUE"] = "#584CE4";
    Colors["LABEL_BLUE_DARK"] = "#372CB4";
    Colors["WHITE_SMOKE_STRONG"] = "#EDEDED";
    Colors["SAVVAS_GREEN"] = "#9eca47";
    Colors["SAVVAS_GREEN_HOVER"] = "#799E2E";
    Colors["LIGHT_MAGENTA"] = "#C94C96";
    Colors["SAVVAS_PLUM"] = "#902364";
    Colors["SAVVAS_PLUM_HOVER"] = "#771D53";
    Colors["LIGHT_MAGENTA_HOVER"] = "#B1357F";
})(Colors || (Colors = {}));
export var ChartType;
(function (ChartType) {
    ChartType["COLUMN"] = "column";
    ChartType["BAR"] = "bar";
})(ChartType || (ChartType = {}));
export var SortingOrder;
(function (SortingOrder) {
    SortingOrder["Ascending"] = "Ascending";
    SortingOrder["Descending"] = "Descending";
})(SortingOrder || (SortingOrder = {}));
export var CEL_ICON_ALIGNMENTS;
(function (CEL_ICON_ALIGNMENTS) {
    CEL_ICON_ALIGNMENTS["ALIGNMENT_LEFT"] = "left";
    CEL_ICON_ALIGNMENTS["ALIGNMENT_RIGHT"] = "right";
})(CEL_ICON_ALIGNMENTS || (CEL_ICON_ALIGNMENTS = {}));
export var CEL_ICON_COLORS;
(function (CEL_ICON_COLORS) {
    CEL_ICON_COLORS["WHITE"] = "white";
    CEL_ICON_COLORS["BLACK"] = "black";
    CEL_ICON_COLORS["DISABLED"] = "disabled";
    CEL_ICON_COLORS["PRIMARY"] = "primary";
    CEL_ICON_COLORS["ERROR_SHADE"] = "error-shade";
    CEL_ICON_COLORS["GRAY_DUSTY"] = "gray-dusty";
})(CEL_ICON_COLORS || (CEL_ICON_COLORS = {}));
export var CEL_ICON_NAMES;
(function (CEL_ICON_NAMES) {
    CEL_ICON_NAMES["CARET_DOWN"] = "caret-down";
    CEL_ICON_NAMES["CARET_LEFT"] = "caret-left";
    CEL_ICON_NAMES["CARET_RIGHT"] = "caret-right";
    CEL_ICON_NAMES["CARET_UP"] = "caret-up";
    CEL_ICON_NAMES["INFORMATION"] = "information";
    CEL_ICON_NAMES["INFORMATION_CIRCLE"] = "information-circle";
    CEL_ICON_NAMES["ARROW_UP"] = "arrow-up";
    CEL_ICON_NAMES["ARROW_DOWN"] = "arrow-down";
    CEL_ICON_NAMES["SORT"] = "sort";
    CEL_ICON_NAMES["ERROR_CLOUD"] = "error-cloud";
    CEL_ICON_NAMES["ARROW_SORT"] = "arrow-sort";
})(CEL_ICON_NAMES || (CEL_ICON_NAMES = {}));
export var CEL_ICON_SIZES;
(function (CEL_ICON_SIZES) {
    CEL_ICON_SIZES["CUSTOM"] = "custom";
    CEL_ICON_SIZES["REGULAR"] = "regular";
    CEL_ICON_SIZES["MEDIUM"] = "medium";
    CEL_ICON_SIZES["SMALL"] = "small";
    CEL_ICON_SIZES["XSMALL"] = "xsmall";
    CEL_ICON_SIZES["XXXLARGE"] = "xxxlarge";
})(CEL_ICON_SIZES || (CEL_ICON_SIZES = {}));
